import Vue from 'vue/dist/vue.js';

export default {
    name      : 'tips',
    _container: null,
    init() {
        this._container = document.querySelector('[data-tips]');
        if (!this._container) {
            return;
        }

        const baseUrl = this._container.getAttribute('data-tips');

        new Vue({
            el: this._container,
            delimiters: ['${', '}'],
            data: {
                apiUrl            : `${baseUrl}/actions/tellus/tellus/get-tips`,
                query             : '',
                articles          : [],
                filteredArticles  : [],
                categories        : [],
                selectedCategories: [],
            },
            created() {
                this.fetchArticles();
            },
            methods: {
                fetchArticles() {
                    const request = new XMLHttpRequest();
                    request.addEventListener('load', () => {
                        if (request.readyState === 4 && request.status === 200) {
                            this.articles = JSON.parse(request.responseText);
                            this.makeCategories();
                            this.update();
                        }
                    });

                    request.open('GET', this.apiUrl);
                    request.send();
                },
                makeCategories() {
                    for (const article of this.articles) {
                        for (const category of article.categories) {
                            if (!this.categories.includes(category)) {
                                this.categories.push(category);
                            }
                        }
                    }
                },
                selectedCategory(category) {
                    return this.selectedCategories.indexOf(category) !== -1;
                },
                toggleCategory(category) {
                    if (this.selectedCategories.indexOf(category) === -1) {
                        this.selectedCategories.push(category);
                    } else {
                        this.selectedCategories = this.selectedCategories.filter(i => i !== category);
                    }

                    this.update();
                },
                matchesSearch(articles) {
                    const search = this.formatString(this.query);
                    
                    let filtered = articles;
                    if (search) {
                        filtered = filtered.filter(i => {
                            const title    = i.title    ? i.title    : '';
                            const intro    = i.intro    ? i.intro    : '';
    
                            return this.formatString(title).includes(search) ||
                                   this.formatString(intro).includes(search)
                        });
                    }

                    return filtered;
                },
                formatString(string) {
                    return string.split(' ').join('').toLowerCase();
                },
                update() {
                    let filteredArticles = this.articles;

                    if (this.selectedCategories.length) {
                        filteredArticles = filteredArticles.filter(a => {
                            for (const category of a.categories) {
                                if (this.selectedCategory(category)) {
                                    return true;
                                }
                            }

                            return false;
                        });
                    }

                    if (this.query.length) {
                        filteredArticles = this.matchesSearch(filteredArticles);
                    }

                    this.filteredArticles = filteredArticles;
                }
            }
        });
    }
}